<template>
  <div class="mc-bar">
    <div class="mc-bar-inner">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BottomBar',
}
</script>

<style scoped>
.mc-bar {
  background: #fff;
  border-top: 1px solid #e8e8e8;
  padding: 12px 20px calc(12px + env(safe-area-inset-bottom, 0px));
  box-shadow: 0 -6px 20px rgba(20, 20, 43, 0.08);
}

.mc-bar-inner {
  display: flex;
  gap: 10px;
}

@media (min-width: 641px) {
  .mc-bar-inner {
    max-width: 680px;
    margin: 0 auto;
  }
}

/* the bar's white background spans the full shell width (see Shell.vue) so it
   reads as one floor with the sidebar card above it; shift the button row
   itself right by the sidebar's width so it still lines up under the form */
@media (min-width: 900px) {
  .mc-bar {
    padding-left: 320px;
  }

  /* the 641px rule's `margin: 0 auto` re-centers the row within whatever
     space is left after the padding above, pushing it further right than
     the padding alone intends — sit flush left instead. Cap matches
     .mc-screen's own 920px max-width (see Shell.vue) so Continue's
     right-aligned edge lines up with the actual right edge of the form
     content, not an arbitrarily narrower boundary */
  .mc-bar-inner {
    max-width: 920px;
    margin: 0;
    justify-content: space-between;
  }
}
</style>

<!-- unscoped: `.mc-btn` classes are used by every motor-claim step's bottom
     bar buttons (they live in the parent step's own template via <slot />,
     so a scoped selector here couldn't reach them) -->
<style>
.mc-btn {
  flex: 1;
  border: 0;
  border-radius: 8px;
  font-family: inherit;
  font-size: 15.5px;
  font-weight: 600;
  padding: 15px 16px;
  cursor: pointer;
  transition: 0.15s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.mc-btn.mc-btn--pri {
  background: #0066cc;
  color: #fff;
}

.mc-btn.mc-btn--pri:active {
  background: #0052b3;
}

.mc-btn.mc-btn--pri:disabled {
  background: #88b9eb;
  cursor: not-allowed;
}

.mc-btn.mc-btn--sec {
  background: #fff;
  color: #0052b3;
  border: 1.5px solid #bdd8f5;
  flex: 0 0 auto;
  padding: 15px 20px;
}

/* on the sidebar breakpoint, when Back is also present, Continue becomes a
   compact right-aligned button (via .mc-bar-inner's justify-content:
   space-between) instead of stretching to fill the whole row. The lone
   Continue button on the Look-up step (no Back sibling) keeps flex:1 */
@media (min-width: 900px) {
  .mc-btn.mc-btn--pri:not(:only-child) {
    flex: 0 0 auto;
    min-width: 200px;
  }
}
</style>
